import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Card,
  Heading,
  CardContent,
  AllStandardColourOptions,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

type WithCardProps = {
  slice: Content.CallToActionSliceWithCard;
};

export const WithCard = ({ slice }: WithCardProps) => {
  const { primary } = slice;
  const { title, caption, link_action } = primary;

  let colour: AllStandardColourOptions | undefined = undefined;

  if (isFilled.link(link_action)) {
    colour = {
      Default: undefined,
      'button-contrast': undefined,
      'button-primary': 'primary' satisfies AllStandardColourOptions,
      'button-negative': 'negative' satisfies AllStandardColourOptions,
    }[link_action?.variant ?? 'Default'] as AllStandardColourOptions;
  }

  const { WebsiteUrl } = applicationEnv();

  return (
    <Card component="div">
      <CardContent>
        <Box component="div" addRepel>
          <Box component="div" addFlow>
            {isFilled.richText(title) && (
              <Heading component="h2" className="notification__heading">
                {asText(title)}
              </Heading>
            )}

            {isFilled.richText(caption) && (
              <RichText
                content={caption}
                variant="default"
                websiteUrl={WebsiteUrl}
              />
            )}
          </Box>

          {isFilled.link(link_action) && (
            <Link
              as="default"
              type="button"
              colour={colour}
              retainSearchParams
              href={link_action.url ?? ''}
              variant={
                link_action?.variant === 'button-contrast'
                  ? 'contrast'
                  : 'solid'
              }
            >
              {link_action.text}
            </Link>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
